/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios, { AxiosInstance } from "axios";
import config from "../config/forgotPassword.config.json";

export interface IForgotPasswordUserMethods extends IPluginMethodMap {
  getForgotPassword(args: any, apiURL: string): Promise<any>;
}

export interface HeaderProps {
  headerName: string;
  headerValue: string;
}

export interface ForgotPasswordProps {
  email: string;
  apiURL: string;
  headers: HeaderProps;
  storeId: string;
}

export class ForgotPasswordService implements IAgentPlugin {
  readonly methods: IForgotPasswordUserMethods;
  constructor() {
    this.methods = {
      getForgotPassword: this.getForgotPassword.bind(this),
    };
  }

  async getForgotPassword(args: ForgotPasswordProps) {
    console.log(`args in sign in user service`, args);
    let headers: any = {};
    headers[args?.headers?.headerName] = args?.headers?.headerValue;
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.forgotPasswordEP}`,
        {
          email: args?.email,
          type: config?.verificationType,
        },
        {
          headers: {
            ...headers,
          },
        }
      );
      if (res?.data) {
        console.log(`forgot password:`, res?.data);
        return {
          ...res?.data,
          email: args?.email,
        };
      }
    } catch (err: any) {
      // return err?.response?.data;
      throw err;
    }
  }
}
